import { useCallback, useEffect, useState } from "react";
import VendorEmailHistory from "./VendorEmailHistory";
import Moment from "moment";
import {
  getFleetVendorEmailHistoryMessage,
  setFleetVendorEmailHistoryMessage,
  getFleetVendorEmailHistory,
} from "Store/FleetManagement/FleetPOVendorEmailHistory/FleetPOVendorEmailHistoryAction";
import { useDispatch, useSelector } from "react-redux";
import { EventHandler } from "../../../../CommonComponents";

const VendorEmailHistoryContainer = (props: any) => {
  const { fleetRequestDetailId, poNumber } = props;
  const dispatch = useDispatch();
  const [paginationData, setPaginationData] = useState<any>({});
  const [pagesCount, setPagesCount] = useState<number>(0);
  const [serverTotal, setServerTotal] = useState(0);
  const [tableData, setTableData] = useState<any>([]);
  const [showMessage, setShowMessage] = useState(false);

  const { fleetPOVendorEmailHistory, fleetVendorEmailHistoryMessage } =
    useSelector((state: any) => ({
      fleetPOVendorEmailHistory:
        state.POVendorEmailHistoryReducers.fleetVendorEmailHistory,
      fleetVendorEmailHistoryMessage:
        state.POVendorEmailHistoryReducers.fleetVendorEmailHistoryMessage,
    }));

  useEffect(() => {
    if (fleetPOVendorEmailHistory?.length) {
      let tempData = fleetPOVendorEmailHistory?.find(
        (item: any) => item?.id == fleetRequestDetailId
      );
      if (tempData?.isOpen) {
        setTableData(tempData?.response?.data);
        setServerTotal(tempData?.response?.totalRecords);
      }
    }
  }, [fleetPOVendorEmailHistory]);

  const onClickViewAttachment = (e?: any, url?: any) => {
    e?.preventDefault();
    let win = window.open();
    if (win) {
      win.document.write(
        '<iframe width="100%" height="100%" src="' +
          url +
          '" frameborder="0" ></iframe>'
      );
    }
  };

  const onClickViewMessage = (e?: any, emailHistoryId?: any) => {
    e?.preventDefault();
    dispatch(
      getFleetVendorEmailHistoryMessage({
        emailHistoryId: emailHistoryId,
        fleetDetailId: fleetRequestDetailId,
      })
    );
  };

  useEffect(() => {
    if (
      fleetVendorEmailHistoryMessage?.hasOwnProperty("subject") &&
      fleetVendorEmailHistoryMessage?.fleetDetailId === fleetRequestDetailId
    ) {
      setShowMessage(true);
    }
  }, [fleetVendorEmailHistoryMessage]);

  const columns = [
    {
      key: "dateSent",
      title: "Date Sent (PST)",
      width: 120,
      Cell: (row: any) => {
        return (
          <p className="dateSubmitted">
            {row?.rowData?.dateSent
              ? Moment(row?.rowData?.dateSent)?.format("MM/DD/YYYY HH:mm:ss A")
              : ""}
          </p>
        );
      },
    },
    {
      key: "fromEmailAddress",
      title: "Sent From",
      width: 120,
    },
    {
      key: "toEmailAddress",
      title: "Sent To",
      width: 120,
      Cell: (row: any) => {
        return row?.rowData?.toEmailAddress?.map((email: any) => {
          return <div>{email}</div>;
        });
      },
    },
    {
      key: "bccEmailAddress",
      title: "BCC",
      width: 120,
      Cell: (row: any) => {
        return row?.rowData?.bccEmailAddress?.map((email: any) => {
          return <div>{email}</div>;
        });
      },
    },
    {
      key: "emailAttachments",
      title: "Attachments",
      width: 120,
      Cell: (row: any) => {
        return row?.rowData?.emailAttachments?.map((attachments: any, index: number) => {
          return (
            <div className="view-link">
              <EventHandler onEvent={(e: any) => onClickViewAttachment(e, attachments?.attachmentUrl)} data-attribute={`VendorEmailHistory_container_${(attachments?.fileName || index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_EventHandler`}>
                <a>
                  <span className="fa fa-paperclip attachment-img"></span> {attachments?.fileName}
                </a>
              </EventHandler>
            </div>
          );
        });
      },
    },
    {
      key: "emailMessage",
      title: "Email Message",
      width: 120,
      Cell: (row: any) => {
        return (
          <EventHandler onEvent={(e: any) => onClickViewMessage(e, row?.rowData?.emailHistoryId)} data-attribute="VendorEmailHistory_container_Default_EventHandler_2">
            <a className="view-link">
              View Message
            </a>
          </EventHandler>
        );
      },
    },
  ];

  useEffect(() => {
    if (serverTotal && paginationData?.pageSize) {
      let pageSize = paginationData?.pageSize;
      let tempPageCount =
        serverTotal > pageSize ? Math.ceil(serverTotal / pageSize - 1) : 0;
      setPagesCount(tempPageCount);
    }
  }, [serverTotal, paginationData?.pageSize]);

  const fetchAction = useCallback((fetchData: any) => {
    if (fetchData.action && fetchData.action === "paging") {
      setPaginationData(fetchData.data);
      if(poNumber){
        dispatch(
          getFleetVendorEmailHistory({
            fleetDetailId: fleetRequestDetailId,
            poNumber: poNumber,
            pageNumber:
              fetchData?.data?.pageIndex != undefined
                ? fetchData?.data?.pageIndex + 1
                : undefined,
            pageSize: fetchData?.data?.pageSize,
          })
        );
      }
    }
  }, []);

  const hidePopup = () => {
    setShowMessage(false);
    dispatch(setFleetVendorEmailHistoryMessage(null));
  };

  return (
    <VendorEmailHistory
      data={tableData}
      columns={columns}
      fetchAction={fetchAction}
      fleetVendorEmailHistoryMessage={fleetVendorEmailHistoryMessage}
      showMessage={showMessage}
      hidePopup={hidePopup}
      serverTotal={serverTotal}
      pagesCount={pagesCount}
    />
  );
};

export default VendorEmailHistoryContainer;
